import React, { useState } from "react";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import {
  sendDataWithDelete,
} from "../../../services/services";
import { styles } from "../../../utils/styles";
import { LoadingButton } from "@mui/lab";

const DeleteDialog = ({ id, cb, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    setIsLoading(true);
    const url = `/mpi_details/${id}/delete/`;
    sendDataWithDelete(
      url,
      () => setIsLoading(false),
      () => {
        cb();
        onClose();
      }
    );
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{"Are you sure you want to delete?"}</DialogTitle>
      <DialogActions>
        <LoadingButton
          variant="outlined"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit}
          loading={isLoading}
          sx={{ ...styles.customButton }}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
